import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import Avatar from '../../avatar/Avatar';
import Image from '../../../../components/image/Image';
import { DATE_FORMAT_EU_DOT, DATE_FORMAT_HOURS_MINUTES } from '../../../../core/constants/date';
import { BASE_URL } from '../../../../core/constants/api';
import Icon from '../../../../components/icon/Icon';

interface Props {
  projectName: string | null;
  date: string;
  name: string | null;
  image: string | null;
  notificationType: number;
}

const HeaderNotificationItem: React.FC<Props> = ({ projectName, date, name, image, notificationType }) => {
  const { t } = useTranslation();
  return (
    <div className="header-notification__item">
      <Avatar className="header-notification__avatar">
        {image ? <Image src={`${BASE_URL}/${image}`} alt="image" /> : <Icon icon="projectsRed" svg />}
      </Avatar>
      <div className="header-notification__item-content">
        <div className="header-notification__item-project-name">{projectName}</div>
        <div className="header-notification__item-text">{t(`notification.bookingType.${notificationType}`)}</div>
        <div className="header-notification__bottom">
          <span className="header-notification__time">
            {format(new Date(date), DATE_FORMAT_EU_DOT)} at {format(new Date(date), DATE_FORMAT_HOURS_MINUTES)}
          </span>
          <span className="header-notification__name">{name}</span>
        </div>
      </div>
    </div>
  );
};

export default HeaderNotificationItem;
